module.exports = __webpack_public_path__ + "img/registration-4000.f9e4f396.png";